/** Align `lg` with Tailwind’s 1024px used by Tradock’s desktop sidebar. */
const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1024,
    xl: 1536,
  },
};

export default breakpoints;
